module.exports = __webpack_public_path__ + "img/diamond.d9d944da.svg";